import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Pick = ({ label, value, onChange, items, testid }) => (
  <div className="min-w-0 space-y-1.5">
    <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full min-w-0 [&>span]:truncate" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{items.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testid}-${v}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);

export const TestEmailButton = ({ hotel }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [v, setV] = useState({ kind: "link", user_id: "", language: "es" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/users").then((r) => { setUsers(r.data.filter((u) => u.active)); setV((s) => ({ ...s, user_id: s.user_id || user.id, language: hotel.language || "es" })); });
  }, [open, user.id, hotel.language]);

  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/hotels/${hotel.slug}/test-email`, v); toast.success(`Correo de prueba enviado a ${data.to}`); setOpen(false); }
    catch (e) { toast.error(apiError(e).message); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button type="button" variant="outline" className="w-full" onClick={() => setOpen(true)} data-testid="hotel-test-email-btn"><Send size={16} className="mr-2" />Enviar correo de prueba</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="admin-shell w-[calc(100vw-2rem)] max-w-md" data-testid="test-email-dialog">
          <DialogHeader>
            <DialogTitle>Correo de prueba · {hotel.display_name}</DialogTitle>
            <DialogDescription>Se envía con datos de muestra. Por seguridad, solo puede llegar a cuentas registradas en el panel.</DialogDescription>
          </DialogHeader>
          <div className="min-w-0 space-y-4">
            <Pick label="Tipo de correo" value={v.kind} onChange={(x) => setV((s) => ({ ...s, kind: x }))} testid="test-email-kind"
              items={[["link", "Enlace de pago"], ["receipt", "Comprobante de pago (con PDF)"]]} />
            <Pick label="Enviar a" value={v.user_id} onChange={(x) => setV((s) => ({ ...s, user_id: x }))} testid="test-email-to"
              items={users.map((u) => [u.id, `${u.name} · ${u.email}`])} />
            <Pick label="Idioma" value={v.language} onChange={(x) => setV((s) => ({ ...s, language: x }))} testid="test-email-lang"
              items={[["es", "Español"], ["en", "English"]]} />
          </div>
          <DialogFooter>
            <Button onClick={send} disabled={busy || !v.user_id} className="bg-[#2F5BFF] hover:bg-[#1F45E0]" data-testid="test-email-send-btn">{busy ? "Enviando…" : "Enviar prueba"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
